type Environment = 'local' | 'staging' | 'production'

export const environment = process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'local' as Environment
